import { rd } from "../../utils";

export const canRefundOrder = (order) => {
  if (order.amount_refund < order.amount) {
    return true;
  }
  return false;
}

// Montant qu'il est encore possible de rembourser EN ARGENT RÉEL sur cette
// commande.
// - Base sur order.refundable_amount : somme des PaymentDetails remboursables
//   (stripe/checkout/edenred/paygreen), déjà nette des remboursements passés et
//   des règles métier (fenêtre 2j Paygreen, token Edenred). Contrairement à
//   order.amount, ça EXCLUT les lignes promotions/credits/cash non remboursables
//   — sinon l'UI surestime et le back refuse (AmountIsTooBigError).
// - On retranche le recrédit déjà accordé au-delà des crédits utilisés : recrédit
//   et remboursement puisent dans la même enveloppe.
// Repli sur order.amount si refundable_amount absent du payload (ex: ?payment=0).
export const orderRemainingRefundableAmount = (order) => {
  const recreditOverCredits = Math.max(
    0,
    (order.amount_recredit || 0) - (order.credits_used || 0),
  );
  const base =
    order.refundable_amount != null
      ? order.refundable_amount
      : (order.amount || 0) - (order.amount_refund || 0);
  return Math.max(0, base - recreditOverCredits);
};

export const orderIsRefundable = (order) =>
  rd(orderRemainingRefundableAmount(order)) > 0;

// Une unité déjà passée par l'un des deux canaux (recredit OU refund) ne
// peut plus repasser par l'autre — la règle est symétrique, d'où un seul
// helper partagé.
export const orderProductRemainingActionableQty = (op) =>
  Math.max(0, op.quantity - op.quantity_recredit - op.quantity_refund);

// Aligné avec OrderAddCredits.MARGE_DEPASSEMENT_TTC côté back
// (DeleevCore/orders/libs/order_add_credits.py).
export const MARGE_DEPASSEMENT_TTC = 20;

// Quantité minimale recréditable/remboursable par produit. On autorise les
// fractions (ex: rembourser 0.2 d'un lot de 10 yaourts) ; le plancher est
// aligné sur l'arrondi à 2 décimales appliqué côté back
// (OrderProduct.get_stock_quantity_from_amount → round(..., 2)) : en deçà de
// 0.01 la quantité serait arrondie à 0 et l'opération deviendrait un no-op.
export const MIN_COMPENSATION_QUANTITY = 0.01;

// Version signée du cap restant pour un dédommagement : peut être négative
// quand la commande a déjà été sur-dédommagée (recredit + refund >
// amount + credits_used). Utile pour calculer la marge restante de
// dépassement sans masquer l'info par un clamp à 0.
export const orderRemainingRecreditAmountRaw = (order) =>
  (order.amount || 0)
  + (order.credits_used || 0)
  - (order.amount_recredit || 0)
  - (order.amount_refund || 0);

// Cap restant pour un dédommagement, miroir de Order.max_possible_recredit_amount
// (sans la marge).
export const orderRemainingRecreditAmount = (order) =>
  Math.max(0, orderRemainingRecreditAmountRaw(order));
